import {
    axiosDelete,
    axiosGet,
    axiosPatch,
    axiosPost,
} from "../axois_V2/axoisWithAuthV2";
import { RsvpStatus } from "../types";
import { UserType } from "../types/auth";
import { throwError } from "../utils/error";

export const memberBaseURL_V2 = "/member/v2";

export interface IMember {
    _id: string;
    name: string;
    email: string;
    userType: UserType;
    position: string;
    organizationName?: string;
    phone: number;
    rsvpStatus?: string;
    campaign?: {
        campaignId: string;
        campaignCode: string;
        campaignName: string;
        isCheckedIn: boolean;
        rsvpStatus: string | null;
    };
    parentId: string;
    createdAt: string;
    updatedAt: string;
    organizationPartner: boolean;
}

export interface CreateMemberPayload {
    name: string;
    phone: number;
    email: string;
    userType: string;
    position: string;
    campaignId?: string;
    organizationName: string;
    organizationPartner?: boolean;
    isCheckedIn?: boolean;
    parentId?: string;
}

export interface UpdateMemberPayload {
    name?: string;
    email?: string
    userType?: string
    position?: string
    campaignId?: string
    organizationName?: string
    phone?: number;
    organizationPartner?: boolean;
    isCheckedIn?: boolean;
    rsvpStatus?: RsvpStatus
}

export const getAllMembers_V2 = async (payload?: { campaignId?: string }) => {
    try {
        const query = payload?.campaignId
            ? `?campaignId=${payload.campaignId}`
            : "";

        const res = await axiosGet(`${memberBaseURL_V2}${query}`);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const getMemberById_V2 = async (id: string, selectedCampaignId?: string) => {
    try {
        const url = selectedCampaignId
            ? `${memberBaseURL_V2}/${id}/${selectedCampaignId}`
            : `${memberBaseURL_V2}/${id}`;
        const res = await axiosGet(url);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const getMemberByEmail_V2 = async (
    params: {
        email?: string;
    }
) => {
    try {
        let url = `${memberBaseURL_V2}/fetch`;
        let payload: { email?: string } | undefined = undefined;

        if (params.email) {
            payload = { email: params.email };
        }

        const res = await axiosPost(url, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
};



export const createMember_V2 = async (payload: CreateMemberPayload) => {
    try {
        const res = await axiosPost(`${memberBaseURL_V2}`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const updateMember_V2 = async (id: string, payload: UpdateMemberPayload) => {
    try {
        const res = await axiosPatch(`${memberBaseURL_V2}/${id}`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const deleteMember_V2 = async (id: string) => {
    try {
        const res = await axiosDelete(`${memberBaseURL_V2}/${id}`);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const importBulkMember = async (file: File) => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const res = await axiosPost(
            `${memberBaseURL_V2}/bulk_import`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return res;
    } catch (error) {
        throwError(error);
    }
};
